import { render } from "./campaign-creator-block.vue?vue&type=template&id=3b84928a&scoped=true"
import script from "./campaign-creator-block.vue?vue&type=script&lang=js"
export * from "./campaign-creator-block.vue?vue&type=script&lang=js"

import "./campaign-creator-block.vue?vue&type=style&index=0&id=3b84928a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b84928a"]])

export default __exports__